import dateFns from 'date-fns'

import AppPage from '../../mixins/app-page'
import AppImg from '../app-img'
import AppBtn from '../app-btn'
import AppYoutube from '../app-youtube'
import AppBtnSocialLink from '../app-btn-social-link'

function clamp(grey, min, max, less)
{
    const out = (grey - min) / (max - min)
    return Math.max(0, Math.min(1, out)) * less
}

function linear(x, xMin = 0, xMax = 1, vMin = 0, vMax = 1)
{
    return Math.max(vMin, Math.min(vMax, (x - xMin) * (vMax - vMin) / (xMax - xMin) + vMin))
}


export default
{
    name: 'page-player',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppImg,
        AppBtn,
        AppYoutube,
        AppBtnSocialLink
    },

    data()
    {
        return {
            player: null,
            currentGameId: -1,
            activePlayerIndex: -1,
            teamAllPlayers: []
        }
    },

    created()
    {
        this.interview = [
            {
                question: 'Where were you born ?',
                answer: 'Port Elizabeth'
            },
            {
                question: 'Do you have a job? If so, what do you do?',
                answer: 'Student - IT'
            },
            {
                question: 'What was the first console/PC you owned?',
                answer: 'PS1'
            },
            {
                question: 'What was the first video game you remember playing?',
                answer: 'Medal of Honor'
            },
            {
                question: 'What was the first game you played competitively?',
                answer: 'FIFA'
            },
            {
                question: 'Where does your in-game nickname come from?',
                answer: 'One of my cs mates back in South Africa called me HoodluM one day and it stuck.'
            },
            {
                question: 'Do you have any tattoos? If so, where and what?',
                answer: 'Yes, left arm, skull with a rose, sleeve in progress'
            },
            {
                question: 'What was the first game you played competitively?',
                answer: 'FIFA'
            },
            {
                question: 'Where does your in-game nickname come from?',
                answer: 'One of my cs mates back in South Africa called me HoodluM one day and it stuck.'
            },
            {
                question: 'Do you have any tattoos? If so, where and what?',
                answer: 'Yes, left arm, skull with a rose, sleeve in progress'
            }
        ]

        this.player = this.contentPage.player
        this.interview = this.contentPage.interview.questions
        if (this.contentPage.team.players)
        {
            this.teamAllPlayers = this.contentPage.team.players.filter(p =>
                parseInt(p.id_game, 10) === this.player.videoGameID
            )
            this.teamAllPlayers.forEach((p, index) =>
            {
                if (parseInt(p.id, 10) === parseInt(this.$route.params.slug, 10))
                {
                    this.activePlayerIndex = index
                }
            })
        }

        this.currentGameId = this.contentPage.player.videoGameID
    },

    mounted()
    {
        if (this.player.photoCover)
        {
            this._startBuildBg(
                this.player.photoCover,
                '/static/bg/bg-empty.jpg')
        }
        else
        {
            const video = this.player.videoCover && !!this.player.videoCover ? this.player.videoCover : null
            const img = this.player.photoCover && !!this.player.photoCover ? this.player.photoCover : '/static/bg/bg-empty.jpg'
            this.eventHub.$emit('bg-change', img, video)
        }
    },

    methods:
    {

        _getPlayerUrlFromIndex(index)
        {
            if (index >= 0 && index < this.teamAllPlayers.length - 1)
            {
                return this.$root.getPageURLFromID('player').replace(':slug', this.teamAllPlayers[index].id)
            }

            return this.$route.path
        },

        getYears(timestamp)
        {
            return dateFns.differenceInYears(Date.now(), timestamp * 1000)
        },

        openModalRegister()
        {
            this.$root.openModalPlay('player', this.contentPage.player.observeId)
        },

        _startBuildBg(playerSrc, bgSrc)
        {
            const playerImg = new Image()
            playerImg.crossOrigin = 'anonymous'
            const bgImg = new Image()
            playerImg.onload = () =>
            {
                bgImg.onload = () =>
                {
                    this._mixBg(playerImg, bgImg)
                }

                bgImg.src = bgSrc
            }

            playerImg.src = playerSrc
        },

        _filterImg(imgData, w, h)
        {
            const greyPower = 1

            const invGrey = (1 - greyPower)
            for (let i = 0; i < imgData.data.length / 4; i++)
            {
                // const x = i % w
                const y = Math.floor(i / w)

                const j = i * 4
                const r = imgData.data[j]
                const g = imgData.data[j + 1]
                const b = imgData.data[j + 2]
                const a = imgData.data[j + 3]

                const grey = Math.round((r + g + b + 255 * linear(y / h, 0.7, 0.2, 0, 0.7)) / 3) * greyPower


                imgData.data[j] = grey + r * invGrey
                imgData.data[j + 1] = grey + g * invGrey
                imgData.data[j + 2] = grey + b * invGrey
                imgData.data[j + 3] = a * clamp(grey / 255, 0.3, 1, 0.4)
            }

            return imgData
        },

        _mixBg(playerImg, bgImg)
        {
            const canvas = document.createElement('canvas')
            canvas.width = bgImg.width
            canvas.height = bgImg.height

            const ctx = canvas.getContext('2d')
            ctx.drawImage(bgImg, 0, 0)


            const sw = playerImg.width
            const sh = playerImg.height

            const h = bgImg.height
            const w = h * sw / sh
            const x = (bgImg.width - w) / 2
            const y = h * 0.1


            // Create temp canvas to filter player
            const tempCanvas = document.createElement('canvas')
            tempCanvas.width = w
            tempCanvas.height = h
            const tmpCtx = tempCanvas.getContext('2d')
            tmpCtx.drawImage(playerImg, 0, 0, playerImg.width, playerImg.height, 0, 0, w, h)
            tmpCtx.putImageData(this._filterImg(tmpCtx.getImageData(0, 0, w, h), w, h), 0, 0)

            ctx.drawImage(tempCanvas, 0, 0, w, h, x, y, w, h)


            const player = this.contentPage.player
            const video = player.videoCover && !!player.videoCover ? player.videoCover : null
            this.eventHub.$emit('bg-change', canvas.toDataURL(), video)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-player/script.js